import { render } from "./ProfileHome.vue?vue&type=template&id=5baa8270"
import script from "./ProfileHome.vue?vue&type=script&lang=js"
export * from "./ProfileHome.vue?vue&type=script&lang=js"

import "./ProfileHome.vue?vue&type=style&index=0&id=5baa8270&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__